/** One recommendation returned by the Historic NAR list endpoint. */
export interface HistoricNarRecommendation {
  identifier: string;
  payer?: string;
  line_of_business?: string;
  plan_name?: string;
  j_code?: string;
  medicine_name?: string;
  month?: string;
  score?: number;
  volume_analytics?: {
    calc1?: number;
    calc2?: number;
    calc3?: number;
    source_text?: Record<string, number>;
  } | null;
  grid_match?: HistoricNarGridMatch | null;
  created_at?: string;
  updated_at?: string;
  ingested?: boolean;
  linked_auth_grid_identifier?: string | null;
  status?: string;
  touchless_enabled_for?: string[];
  agentic_enabled_for?: string[];
}

export type HistoricNarGridMatch =
  "linked" | "created" | "not_found" | "unmapped";

/** Automation arrays are required even when neither mode has clients selected. */
export interface HistoricNarAutomation {
  agent_client_ids: string[];
  touchless_client_ids: string[];
}

export interface ListHistoricNarRequest {
  payer?: string;
  line_of_business?: string;
  j_code?: string;
  min_score?: number;
  ingested?: boolean;
  include_unmapped?: boolean;
  include_past_months?: boolean;
  limit?: number;
  offset?: number;
}

export interface ListHistoricNarResponse {
  items: HistoricNarRecommendation[];
  total: number;
  limit: number;
  offset: number;
}

export type ListAllHistoricNarFilters = Omit<
  ListHistoricNarRequest,
  "limit" | "offset"
>;

export interface IngestHistoricNarRequest {
  identifier: string;
  automation: HistoricNarAutomation;
  source_text: string;
  source_file?: string;
  never_expire?: boolean;
}

export interface IngestHistoricNarResponse {
  success: boolean;
  created: boolean;
  linked_auth_grid_identifier?: string | null;
  grid_match: HistoricNarGridMatch;
  message: string;
}

export enum HistoricNarClearReason {
  FLIP_WAS_WRONG = "flip_was_wrong",
  ONE_OFF_EXCEPTION = "one_off_exception",
  PAYER_CHANGED_POLICY = "payer_changed_policy",
  DO_NOT_AUTOMATE = "do_not_automate",
}

export interface ClearHistoricNarLaneRequest {
  identifier: string;
  reason: HistoricNarClearReason;
  notes?: string;
  order_ids?: string[];
  actor?: string;
}

export interface ClearHistoricNarLaneResponse {
  cleared: boolean;
  state: string;
}
